<div class="modal">
    <div class="header">
        <div class="smash-logo">
            <i class="icon-smash_icologo_chip"></i>
        </div>
        <div class="title title-big">{{ title }}</div>
    </div>
    <div class="body">
        <div class="section">
            <p>{{ description }}</p>
        </div>
    </div>
    <div class="footer">
        <button class="btn-new" [class.red]="!hasPrimaryAction" [class.white]="hasPrimaryAction" (click)="closed.emit()">{{ closeLabel }}</button>
        @if (primaryLabel) {
            <button class="btn-new red" (click)="primaryAction.emit()">{{ primaryLabel }}</button>
        }
    </div>
</div>
